import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../../lib/api-client";
import type { PaymentDetails } from "../../components/payment/PaymentInstructions";

export interface StoreConfig {
  storeName: string;
  logoUrl: string | null;
  whatsappNumber: string;
  defaultAdvancePercent: number;
  googleClientId: string | null;
  payment: PaymentDetails;
  banner: { imageUrl: string; text: string | null; link: string | null } | null;
  stats: {
    happyCustomers: string | null;
    ordersDelivered: string | null;
    qualityProducts: string | null;
    supportAvailability: string | null;
  } | null;
}

export function useStoreConfig() {
  return useQuery({
    queryKey: ["config"],
    queryFn: () => apiFetch<StoreConfig>("/config"),
    staleTime: Infinity
  });
}
